module.exports = __webpack_public_path__ + "static/media/  (107).1472b5d2.jpg";